import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { type NameInputViewModel } from '@/features/jobs/drafting/NameInputViewModel'

export interface CompactNameInputContainerProps {
  vm: NameInputViewModel
}

export const CompactNameInputContainer = observer(
  function CompactNameInputContainer({ vm }: CompactNameInputContainerProps) {
    return (
      <TextInputContainer
        model={vm}
        field="name"
        name="name"
        placeholder="Customize the job's name. Optional."
        data-test="compact-name-input"
        isDisabled={vm.disabled}
        onFocus={vm.step.onBecameActive}
        focus$={vm.step.becomeActive$}
        onBlur={vm.commitName}
      />
    )
  },
)
